var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowforceServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "FlowForce_Server",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.a{fill:#fdd001}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b4c99",
    d: "M3 3h52v52H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32.2 3.4-.3 1.1c-4.9-.6-10 .3-14.6 2.8-2 1.1-3.8 2.4-5.4 3.9l3.7 3.3c1.2-1.1 2.5-2.1 4-2.9C23.2 9.7 27 9 30.8 9.4l-.3 1.3 5.8-2.4-4.1-4.9zM10.7 21.6l.9.7V16l-6 1.9 1 .7c-3 6.4-3.1 14.1.1 20.9L11 37c-2.2-4.9-2.2-10.5-.3-15.4zm42.5 2.6c-.5-2.4-1.3-4.7-2.5-6.9-2.4-4.4-5.9-7.8-10-10l-2 4.5c3.1 1.8 5.9 4.4 7.7 7.8.8 1.5 1.4 3.1 1.8 4.7h-1.3l3.9 5 3.6-5.2-1.2.1zm0 9.3-4.9-.5c-1.1 5.3-4.3 10-9.2 13l-.4-1.1-3.4 5.3 6.1 1.6-.5-1.2c6.7-3.7 11-10.1 12.3-17.1zM31.1 48.6c-5.4.6-10.9-1.1-15.1-4.8l1-.7-6-1.7h-.1v.1l.2 6.2 1-.8c5.4 5 12.7 7.4 20 6.5l-1-4.8z",
    fill: "#81c4ea"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 18.9c0-2.5-1.8-4.5-4.1-4.5h-9.7c-5.2 0-8.4 4.4-8.4 8.6v18c0 2.4 2 3.9 5.2 3.9 2.3 0 4.9-1.6 4.9-4.1v-9.3c0-.6.6-1 1.3-1h5.1c1.6 0 3.6-1.2 3.6-4.4 0-1.3-.3-2.3-.8-3 .6-.1 1.2-.5 1.7-1 .7-.7 1.2-2 1.2-3.2z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21 23.1c0-2.8 2.1-6.6 6.4-6.6h9.7c1.3 0 2.1 1.3 2.1 2.5 0 1-.7 2.3-1.7 2.3H29c-.8 0-1.9 1-1.9 2v17.6c0 1.5-1.8 2.1-2.9 2.1-1.1 0-3.2-.3-3.2-2V23.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.5 28.6c1.5 0 1.6-1.6 1.6-2.4 0-.8-.2-2.4-1.6-2.4h-4.7c-1.5 0-1.6 1.6-1.6 2.4 0 .8.2 2.4 1.6 2.4h4.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowforceServer);
export default __webpack_public_path__ + "static/media/flowforce_server.de8c40561c6ec2a27234c869a38d1e1b.svg";
export { ForwardRef as ReactComponent };